import images from "./images";

export const awards = [
  {
    imgUrl: images.award02,
    title: "Bib Gourmand",
    subtitle:
      "Your talent, dedication, and hard work have truly paid off. Keep shining bright!",
  },
  {
    imgUrl: images.award01,
    title: "Rising Star",
    subtitle: "Your talent, ambition, and dedication are truly inspiring. Keep reaching for the stars!",
  },
  {
    imgUrl: images.award05,
    title: "AA Hospitality",
    subtitle: "Your commitment to excellence and dedication to providing outstanding hospitality are truly commendable. Keep up the exceptional work!",
  },
  {
    imgUrl: images.award03,
    title: "Outstanding Chef",
    subtitle: "Congratulations on being named Outstanding Chef! Your culinary mastery and dedication to excellence are truly remarkable. Keep inspiring us with your incredible talent!",
  },
]
